import React from 'react'
import { connect } from 'react-redux'
import ShareByEmailForm from './ShareByEmailForm'
import ShareThis, { ShareOption } from 'components/Vendor/ShareThis'
import LineEnvelopeIcon from 'components/Luxkit/Icons/line/LineEnvelopeIcon'
import { copyAvailable } from 'lib/web/clipboardUtils'
import { isLoggedIn } from 'selectors/accountSelectors'
import LineLinkIcon from 'components/Luxkit/Icons/line/LineLinkIcon'
import { EMAIL_MODE, ShareConfig } from './ShareModal'
import Group from 'components/utils/Group'
import TextButton from 'components/Luxkit/Button/TextButton'
import styled from 'styled-components'
import BodyText from 'components/Luxkit/Typography/BodyText'
import { rem } from 'polished'

interface Props {
  loggedIn?: boolean;
  shareConfig: ShareConfig;
  mailTo: string | undefined;
  onShare: (shareMethod: string, shareMethodKey?: string) => void;
  closeShareModal: () => void;
  copyToClipboard: () => void;
  mode?: typeof EMAIL_MODE;
  setMode?: React.Dispatch<React.SetStateAction<'email' | undefined>>
}

const ShareLinkTextContainer = styled.div`
  cursor: pointer;
  background: ${({ theme }) => theme.palette.neutral.default.six};
  overflow: hidden;
  padding: ${rem(12)};
`

const CopyLinkOuterContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.neutral.default.five};
  overflow: hidden;
`

function ShareModalContentVariant(props: Props) {
  const {
    shareConfig,
    loggedIn,
    mailTo,
    onShare,
    closeShareModal,
    copyToClipboard,
    mode,
    setMode,
  } = props

  const shareMessage = shareConfig.shareMessage || ''

  return <>
    {mode === EMAIL_MODE && (<ShareByEmailForm
          onShare={onShare}
          closeShareModal={closeShareModal}
          shareMessage={shareMessage}
          shareConfig={shareConfig}
        />)}
    {mode !== EMAIL_MODE && (
      <Group direction="vertical" gap={16}>
        <div>
          <ShareThis onShare={onShare} shareConfig={shareConfig}/>
          <ShareOption
              kind="tertiary"
              href={mailTo}
              onClick={() => {
                loggedIn ? setMode?.(EMAIL_MODE) : onShare('email')
              }}
              startIcon={<LineEnvelopeIcon />}
            >
            Email
          </ShareOption>
        </div>
        {copyAvailable() && (<CopyLinkOuterContainer>
          <Group direction="horizontal" gap={0} verticalAlign="center" >
            <ShareLinkTextContainer onClick={copyToClipboard}>
              <BodyText variant="small" wrap="truncate" colour="neutral-three">
                {props.shareConfig.url?.replace('https://', '')}
              </BodyText>
            </ShareLinkTextContainer>
            <TextButton kind="tertiary" onClick={copyToClipboard} startIcon={<LineLinkIcon />}>
              Copy link
            </TextButton>
          </Group>
        </CopyLinkOuterContainer>
        )}
      </Group>
    )}
  </>
}

function mapStateToProps(state: App.State) {
  return {
    loggedIn: isLoggedIn(state),
  }
}

export default connect(mapStateToProps)(ShareModalContentVariant)
